import { defineFilterSpec, enumField, multiField, text } from '@/lib/api/filter-spec';

import type { DealerDeviceFilterFormValues, DealerDeviceFilters } from './types';

/** Dealer device-table filter serialization (drawer draft <-> applied <-> query). Each multi
 *  field goes out comma-separated, which the BE splits; `category` matches by NAME;
 *  the `YYYY-MM-DD` date bounds pass through as strings (`enumField` strips falsy). */
const spec = defineFilterSpec<DealerDeviceFilters, DealerDeviceFilterFormValues>([
  text('search'),
  multiField('category'),
  multiField('deviceType'),
  multiField('deviceStatus'),
  multiField('subscriptionStatus'),
  enumField('dateFrom'),
  enumField('dateTo'),
]);

export const dealerDeviceToListQuery = spec.toListQuery;
export const dealerDeviceToDefaults = spec.toDefaults;
export const dealerDeviceToFilters = spec.toFilters;
export const dealerDeviceHasActiveFilters = spec.hasActiveFilters;
